import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import DateRangeFilter from '../dateRangeFilter';
import { format } from 'date-fns';
import SelectField from '../../forms/selectOption';
import { 
  getAtcNumberList,
  getOtNumberList,
  getGraphNumberList,
  getStatusATCList,
  getStatusPriceList,
  getSolpedNumberList,
  getSupervisorList,
  getBusinessUnitList,
  getWorkTypeList,
  getSolpedStatusList,
  getHesStatusList,
  getSubtypeList,
  getCentersList,
  getStatusGeneralList
} from '../../../client/atc';

const ListFilterATCAdmin = ({
  titleOption = "Filtrar",
  filters,
  onFilterChange = () => {},
  onDateRangeChange = () => {},
  applyFilters,
  resetFlag,
  activeFilters = {},
  widthPx = 105,
  position = "md:right-0 right-auto"
}) => {

  const [showFilters, setShowFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});

  const [unidadNegocioOptions, setUnidadNegocioOptions] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState([]);
  const [loadingUnidadNegocio, setLoadingUnidadNegocio] = useState(false);

  const [numeroATCOptions, setNumeroATCOptions] = useState([]);
  const [selectedNumeroATC, setSelectedNumeroATC] = useState([]);
  const [loadingNumeroATC, setLoadingNumeroATC] = useState(false);

  const [numeroOTOptions, setNumeroOTOptions] = useState([]);
  const [selectedNumeroOT, setSelectedNumeroOT] = useState([]);
  const [loadingNumeroOT, setLoadingNumeroOT] = useState(false);

  const [numeroGrafoOptions, setNumeroGrafoOptions] = useState([]);
  const [selectedNumeroGrafo, setSelectedNumeroGrafo] = useState([]);
  const [loadingNumeroGrafo, setLoadingNumeroGrafo] = useState(false);

  const [centersOptions, setCentersOptions] = useState([]);
  const [selectedCenters, setSelectedCenters] = useState([]);
  const [loadingCenters, setLoadingCenters] = useState(false);

  const [estadoATCOptions, setEstadoATCOptions] = useState([]);
  const [selectedEstadoATC, setSelectedEstadoATC] = useState([]);
  const [loadingEstadoATC, setLoadingEstadoATC] = useState(false);

  const [estadoCotizacionOptions, setEstadoCotizacionOptions] = useState([]);
  const [selectedEstadoCotizacion, setSelectedEstadoCotizacion] = useState([]);
  const [loadingEstadoCotizacion, setLoadingEstadoCotizacion] = useState(false);

  const [numeroSolpedOptions, setNumeroSolpedOptions] = useState([]);
  const [selectedNumeroSolped, setSelectedNumeroSolped] = useState([]);
  const [loadingNumeroSolped, setLoadingNumeroSolped] = useState(false);

  const [estadoSolpedOptions, setEstadoSolpedOptions] = useState([]);
  const [selectedEstadoSolped, setSelectedEstadoSolped] = useState('');
  const [loadingEstadoSolped, setLoadingEstadoSolped] = useState(false);

  const [estadoHESOptions, setEstadoHESOptions] = useState([]);
  const [selectedEstadoHES, setSelectedEstadoHES] = useState('');
  const [loadingEstadoHES, setLoadingEstadoHES] = useState(false);

  const [supervisorOptions, setSupervisorOptions] = useState([]);
  const [selectedSupervisor, setSelectedSupervisor] = useState([]);
  const [loadingSupervisor, setLoadingSupervisor] = useState(false);

  const [tipoMantenimientoOptions, setTipoMantenimientoOptions] = useState([]);
  const [selectedTipoMantenimiento, setSelectedTipoMantenimiento] = useState([]);
  const [loadingTipoMantenimiento, setLoadingTipoMantenimiento] = useState(false);

  const [subtipoMantenimientoOptions, setSubtipoMantenimientoOptions] = useState([]);
  const [selectedSubtipoMantenimiento, setSelectedSubtipoMantenimiento] = useState([]);
  const [loadingSubtipoMantenimiento, setLoadingSubtipoMantenimiento] = useState(false);

  const [estadoGeneralOptions, setEstadoGeneralOptions] = useState([]);
  const [selectedEstadoGeneral, setSelectedEstadoGeneral] = useState([]);
  const [loadingEstadoGeneral, setLoadingEstadoGeneral] = useState(false);

  // Fechas de creación
const [selectedCreationDateRange, setSelectedCreationDateRange] = useState({
  startDate: '',
  endDate: ''
});

  useEffect(() => {
    setSelectedUnidadNegocio([]);
    setSelectedNumeroATC([]);
    setSelectedNumeroOT([]);
    setSelectedNumeroGrafo([]);
    setSelectedCenters([]); 
    setSelectedEstadoATC([]);
    setSelectedEstadoCotizacion([]);
    setSelectedNumeroSolped([]);
    setSelectedEstadoSolped('');
    setSelectedEstadoHES('');
    setSelectedSupervisor([]);
    setSelectedTipoMantenimiento([]);
    setSelectedSubtipoMantenimiento([]);
    setSelectedEstadoGeneral([]); 
    setSelectedCreationDateRange({ startDate: '', endDate: '' });
    setSelectedFilters({});
  }, [resetFlag]);

useEffect(() => {
  
  setSelectedCreationDateRange({
    startDate: activeFilters.creationDateFrom || '',
    endDate: activeFilters.creationDateTo || ''
  });
    
}, [activeFilters, resetFlag]);

  // Lista números ATC 
  const loadAtcNumbers = async () => {
    try {
      setLoadingNumeroATC(true);
      const response = await getAtcNumberList(); 
      
      const options = response.atcNumbers.map(numero => ({
        value: numero,
        label: numero
      }));
      
      setNumeroATCOptions(options);
    } catch (error) {
      console.error('Error cargando números ATC:', error);
      setNumeroATCOptions([]);
    } finally {
      setLoadingNumeroATC(false);
    }
  };

  //Listar números OT
  const loadOtNumbers = async () => {
    try {
      setLoadingNumeroOT(true);
      const response = await getOtNumberList();
      
      const options = response.otNumbers.map(numero => ({
        value: numero,
        label: numero
      }));
      
      setNumeroOTOptions(options);
    } catch (error) {
      console.error('Error cargando números OT:', error);
      setNumeroOTOptions([]);
    } finally {
      setLoadingNumeroOT(false);
    }
  };

  //Listar numero de grafos
  const loadGraphNumbers = async () => {
    try {
      setLoadingNumeroGrafo(true);
      const response = await getGraphNumberList();
      
      const options = response.graphNumbers.map(numero => ({
        value: numero,
        label: numero
      }));
      
      setNumeroGrafoOptions(options);
    } catch (error) {
      console.error('Error cargando números grafo:', error);
      setNumeroGrafoOptions([]);
    } finally {
      setLoadingNumeroGrafo(false);
    }
  };
  
  //Listar status ATC
  const loadStatusAtc = async () => {
    try {
      setLoadingEstadoATC(true);
      const response = await getStatusATCList();
      
      const options = response.map(status => ({
        value: status.id.toString(), 
        label: status.name
      }));
      
      setEstadoATCOptions(options);
    } catch (error) {
      console.error('Error cargando estados atc:', error);
      setEstadoATCOptions([]);
    } finally {
      setLoadingEstadoATC(false);
    }
  };

  //Listar estados de cotizacion
  const loadStatusPriceList = async () => {
    try {
      setLoadingEstadoCotizacion(true);
      const response = await getStatusPriceList();
      
      const options = response.priceStatusList.map(numero => ({
        value: numero,
        label: numero
      }));
      
      setEstadoCotizacionOptions(options);
    } catch (error) {
      console.error('Error cargando estados de cotización:', error);
      setEstadoCotizacionOptions([]);
    } finally {
      setLoadingEstadoCotizacion(false);
    }
  };

  //Listar numero solped
  const loadSolpedNumbers = async () => {
    try {
      setLoadingNumeroSolped(true);
      const response = await getSolpedNumberList();
      
      const options = response.solpedNumbersList.map(numero => ({
        value: numero,
        label: numero
      }));
      
      setNumeroSolpedOptions(options);
    } catch (error) {
      console.error('Error cargando números solped:', error);
      setNumeroSolpedOptions([]);
    } finally {
      setLoadingNumeroSolped(false);
    }
  };
  
  //Lista supervisores 
  const loadSupervisors = async () => {
    try {
      setLoadingSupervisor(true);
      const response = await getSupervisorList();
      
      const options = response.supervisorsList.map(nombre => ({
        value: nombre,
        label: nombre
      }));
      
      setSupervisorOptions(options);
    } catch (error) {
      console.error('Error cargando supervisores:', error);
      setSupervisorOptions([]);
    } finally {
      setLoadingSupervisor(false);
    }
  };

  //Lista unidades de negocio
  const loadBusinessUnit = async () => {
    try {
      setLoadingUnidadNegocio(true);
      const response = await getBusinessUnitList();
      
      const options = response.businessUnitList.map(nombre => ({
        value: nombre,
        label: nombre
      }));
      
      setUnidadNegocioOptions(options);
    } catch (error) {
      console.error('Error cargando unidades de negocio:', error);
      setUnidadNegocioOptions([]);
    } finally {
      setLoadingUnidadNegocio(false);
    }
  };

  //Lista tipo de mantenimiento 
  const loadWorkType = async () => {
    try {
      setLoadingTipoMantenimiento(true);
      const response = await getWorkTypeList();
      
      const options = response.workTypeList.map(nombre => ({
        value: nombre,
        label: nombre
      }));
      
      setTipoMantenimientoOptions(options);
    } catch (error) {
      console.error('Error cargando tipos de mantenimiento:', error);
      setTipoMantenimientoOptions([]);
    } finally {
      setLoadingTipoMantenimiento(false);
    }
  };

  //Lista de estados solped 
  const loadSolpedStatus = async () => {
    try {
      setLoadingEstadoSolped(true);
      const response = await getSolpedStatusList();
      
      const options = response.solpedStatus.map(item => ({
        value: item.value.toString(),
        label: item.label
      }));
      
      setEstadoSolpedOptions(options);
    } catch (error) {
      console.error('Error cargando estados solped:', error);
      setEstadoSolpedOptions([]);
    } finally {
      setLoadingEstadoSolped(false);
    }
  };

  //Lista estados HES
  const loadHesStatus = async () => {
    try {
      setLoadingEstadoHES(true);
      const response = await getHesStatusList();
      
      const options = response.hesStatus.map(item => ({
        value: item.value.toString(),
        label: item.label
      }));
      
      setEstadoHESOptions(options);
    } catch (error) {
      console.error('Error cargando estados hes:', error);
      setEstadoHESOptions([]);
    } finally {
      setLoadingEstadoHES(false);
    }
  };


// Lista subtipos de mantenimiento
const loadSubtypeList = async () => {
  try {
    setLoadingSubtipoMantenimiento(true);
    const response = await getSubtypeList();
    
    const options = response.subtypes.map(subtype => ({
      value: subtype.id.toString(), 
      label: `${subtype.name} ` 
    }));
    
    setSubtipoMantenimientoOptions(options);
  } catch (error) {
    console.error('Error cargando subtipos de mantenimiento:', error);
    setSubtipoMantenimientoOptions([]);
  } finally {
    setLoadingSubtipoMantenimiento(false);
  }
};

//Lista embarcacion(centros)
  const loadCentersList = async () => {
    try {
      setLoadingCenters(true);
      const response = await getCentersList(); 
      
      const options = response.centersList.map(center => ({
        value: center,
        label: center
      }));
      
      setCentersOptions(options);
    } catch (error) {
      console.error('Error cargando embarcaciones:', error);
      setCentersOptions([]);
    } finally {
      setLoadingCenters(false);
    }
  };

const loadStatusGeneral = async () => {
  try {
    setLoadingEstadoGeneral(true);
    const response = await getStatusGeneralList();
    
    const options = response.statuses.map(status => ({
      value: status.id.toString(),
      label: status.description
    }));
    
    setEstadoGeneralOptions(options);
  } catch (error) {
    console.error('Error cargando estados generales:', error);
    setEstadoGeneralOptions([]);
  } finally {
    setLoadingEstadoGeneral(false);
  }
};

  useEffect(() => {
    if (showFilters) {
      loadAtcNumbers();
      loadOtNumbers();
      loadGraphNumbers();
      loadStatusAtc();
      loadStatusPriceList();
      loadSolpedNumbers();
      loadSupervisors();
      loadBusinessUnit();
      loadWorkType();
      loadSolpedStatus();
      loadHesStatus();
      loadSubtypeList();
      loadCentersList();
      loadStatusGeneral(); 
      
      setUnidadNegocioOptions([]);
      setNumeroATCOptions([]);
      setNumeroOTOptions([]);
      setNumeroGrafoOptions([]);
      setCentersOptions([]);
      setEstadoATCOptions([]);
      setEstadoCotizacionOptions([]);
      setNumeroSolpedOptions([]);
      setEstadoSolpedOptions([]);
      setEstadoHESOptions([]);
      setSupervisorOptions([]);
      setTipoMantenimientoOptions([]);
      setSubtipoMantenimientoOptions([]);
      setEstadoGeneralOptions([]); 
    }
  }, [showFilters]);

  const toggleFilters = () => setShowFilters(!showFilters);

  const handleDateRangeChange = ({ startDate, endDate }) => {
    setSelectedCreationDateRange({ startDate, endDate });
    onDateRangeChange({ startDate, endDate });
  };

  const handleUnidadNegocioChange = (selectedOptions) => {
    setSelectedUnidadNegocio(selectedOptions);
    onFilterChange(
      "Unidad de negocio:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleNumeroATCChange = (selectedOptions) => {
    setSelectedNumeroATC(selectedOptions);
    onFilterChange(
      "Número de ATC:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleNumeroOTChange = (selectedOptions) => {
    setSelectedNumeroOT(selectedOptions);
    onFilterChange(
      "Número de OT:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleNumeroGrafoChange = (selectedOptions) => {
    setSelectedNumeroGrafo(selectedOptions);
    onFilterChange(
      "Número de grafo:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleCentersChange = (selectedOptions) => {
    setSelectedCenters(selectedOptions);
    onFilterChange(
      "Embarcación:",
      selectedOptions.map(option => option.value)
    );
  };

const handleEstadoATCChange = (selectedOptions) => {
  setSelectedEstadoATC(selectedOptions);
  onFilterChange(
    "Estado ATC:",
    selectedOptions.map(option => option.value) 
  );
};

  const handleEstadoCotizacionChange = (selectedOptions) => {
    setSelectedEstadoCotizacion(selectedOptions);
    onFilterChange(
      "Estado Cotización:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleNumeroSolpedChange = (selectedOptions) => {
    setSelectedNumeroSolped(selectedOptions);
    onFilterChange(
      "Número Solped:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleEstadoSolpedChange = (e) => {
    const value = e.target.value;
    setSelectedEstadoSolped(value);
    
    let booleanValue;
    if (value === "true") {
      booleanValue = [true];
    } else if (value === "false") {
      booleanValue = [false];
    } else {
      booleanValue = [];
    }
    
    onFilterChange("Estado de Solped:", booleanValue);
  };

  const handleEstadoHESChange = (e) => {
    const value = e.target.value;
    setSelectedEstadoHES(value);
    
    let booleanValue;
    if (value === "true") {
      booleanValue = [true];
    } else if (value === "false") {
      booleanValue = [false];
    } else {
      booleanValue = [];
    }
    
    onFilterChange("Estado de HES:", booleanValue);
  };

  const handleSupervisorChange = (selectedOptions) => {
    setSelectedSupervisor(selectedOptions);
    onFilterChange(
      "Supervisor de mantenimiento:",
      selectedOptions.map(option => option.value)
    );
  };

  const handleTipoMantenimientoChange = (selectedOptions) => {
    setSelectedTipoMantenimiento(selectedOptions);
    onFilterChange(
      "Tipo de mantenimiento:",
      selectedOptions.map(option => option.value)
    );
  };

const handleSubtipoMantenimientoChange = (selectedOptions) => {
  setSelectedSubtipoMantenimiento(selectedOptions);
  onFilterChange(
    "Subtipo de mantenimiento:",
    selectedOptions.map(option => parseInt(option.value)) 
  );
};

const handleEstadoGeneralChange = (selectedOptions) => {
  setSelectedEstadoGeneral(selectedOptions);
  onFilterChange(
    "Estado general del servicio:",
    selectedOptions.map(option => parseInt(option.value))
  );
};

  const hasActiveFilters = () => {

  const hasDateFilters = 
    activeFilters.creationDateFrom && 
    activeFilters.creationDateTo && 
    activeFilters.creationDateFrom !== '' && 
    activeFilters.creationDateTo !== '';

    return (
      (activeFilters.unidadNegocio && activeFilters.unidadNegocio.length > 0) ||
      (activeFilters.numeroATC && activeFilters.numeroATC.length > 0) ||
      (activeFilters.numeroOT && activeFilters.numeroOT.length > 0) ||
      (activeFilters.numeroGrafo && activeFilters.numeroGrafo.length > 0) ||
      (activeFilters.centers && activeFilters.centers.length > 0) ||
      (activeFilters.estadoATC && activeFilters.estadoATC.length > 0) ||
      (activeFilters.estadoCotizacion && activeFilters.estadoCotizacion.length > 0) ||
      (activeFilters.numeroSolped && activeFilters.numeroSolped.length > 0) ||
      (activeFilters.estadoSolped && activeFilters.estadoSolped.length > 0) ||
      (activeFilters.estadoHES && activeFilters.estadoHES.length > 0) ||
      (activeFilters.supervisor && activeFilters.supervisor.length > 0) ||
      (activeFilters.tipoMantenimiento && activeFilters.tipoMantenimiento.length > 0) ||
      (activeFilters.subtipoMantenimiento && activeFilters.subtipoMantenimiento.length > 0) ||
      (activeFilters.estadoGeneral && activeFilters.estadoGeneral.length > 0) ||
      hasDateFilters
    );
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '40px',
      maxHeight: '120px',
      overflow: 'auto',
      borderColor: '#D1D5DB',
      '&:hover': { borderColor: '#D1D5DB' },
      boxShadow: state.isFocused ? 'none' : base.boxShadow,
    }),
    menu: (base) => ({
      ...base,
      position: 'absolute',
      zIndex: 9999,
      marginTop: '4px',
      width: '100%',
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
  };

const validateNumericInput = (inputValue, action) => {
  if (action === 'input-change') {
    return inputValue.replace(/[^0-9]/g, '');
  }
  return inputValue;
};

  const numericFilterOption = (option, rawInput) => {
    const input = rawInput.replace(/[^0-9]/g, '');
    return option.label.includes(input);
  };

const handleKeyDownNumeric = (e) => {
  const allowedKeys = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    'Home', 'End'
  ];
  
  if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
    return; 
  }
  
  if (!/^\d$/.test(e.key)) {
    e.preventDefault(); 
  }
};

const validateTextInput = (inputValue, action) => {
  if (action === 'input-change') {
    return inputValue.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
  }
  return inputValue;
};

const textFilterOption = (option, rawInput) => {
  const input = rawInput.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
  return option.label.toLowerCase().includes(input.toLowerCase());
};

const handleKeyDownText = (e) => {
  
  const allowedKeys = [
    'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
    'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
    'Home', 'End', ' '
  ];
  
  if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
    return; 
  }
  
  if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key)) {
    e.preventDefault(); 
  }
};

  return (
    <div className='relative'>
      <button
        onClick={toggleFilters}
        className={`flex items-center justify-center font-itcbook px-2 w-[${widthPx}px] border-blue-light text-sm border-[1px] h-[40px] rounded-lg ${
          hasActiveFilters() ? 'bg-blue-light text-white' : 'bg-transparent text-[#6B7280]'
        }`}
      >
        {titleOption}
      </button>
      
      {showFilters && (
        <div
          onClick={(e) => e.stopPropagation()}
          className={`md:p-4 p-4 md:px-5 bg-white absolute ${position} top-12 overflow-y-auto max-h-[450px] rounded-lg w-[266px] sm:w-[372px] z-10 shadow-[0px_1px_3px_0px_#0000004D,0px_4px_8px_3px_#00000026]`}
        >
          <div className='flex flex-col gap-3'>
            <p className='text-base text-blue font-itcbold'>Filtrar por</p>
            <div className='w-full h-[1px] md:my-2 bg-[#D9D9D9]'></div>


            {/* Estado General del servicio */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Estado general del servicio</p>
              <Select
                isMulti
                isLoading={loadingEstadoGeneral}
                isDisabled={loadingEstadoGeneral}
                options={estadoGeneralOptions}
                value={selectedEstadoGeneral}
                onChange={handleEstadoGeneralChange}
                placeholder="Seleccione estados"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                onInputChange={validateTextInput}
                filterOption={textFilterOption}
                onKeyDown={handleKeyDownText}
              />
            </div>


            {/* Unidad de negocio */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Unidad de negocio</p>
              <Select
                isMulti
                isLoading={loadingUnidadNegocio}
                isDisabled={loadingUnidadNegocio}
                options={unidadNegocioOptions}
                value={selectedUnidadNegocio}
                onChange={handleUnidadNegocioChange}
                placeholder="Seleccione unidades"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
              />
            </div>

            {/* Número de ATC */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Número de ATC</p>
              <Select
                isMulti
                isLoading={loadingNumeroATC}
                isDisabled={loadingNumeroATC}
                options={numeroATCOptions}
                value={selectedNumeroATC}
                onChange={handleNumeroATCChange}
                placeholder="Seleccione números ATC"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                onInputChange={validateNumericInput}
                filterOption={numericFilterOption}
                onKeyDown={handleKeyDownNumeric}
              />
            </div>

            {/* Número de OT */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Número de OT</p>
              <Select
                isMulti
                isLoading={loadingNumeroOT}
                isDisabled={loadingNumeroOT}
                options={numeroOTOptions}
                value={selectedNumeroOT}
                onChange={handleNumeroOTChange}
                placeholder="Seleccione números de OT"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                onInputChange={validateNumericInput}
                filterOption={numericFilterOption}
                onKeyDown={handleKeyDownNumeric}
              />
            </div>

            {/* Número de grafo */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Número de grafo</p>
              <Select
                isMulti
                isLoading={loadingNumeroGrafo}
                isDisabled={loadingNumeroGrafo}
                options={numeroGrafoOptions}
                value={selectedNumeroGrafo}
                onChange={handleNumeroGrafoChange}
                placeholder="Seleccione números grafo"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                onInputChange={validateNumericInput}
                filterOption={numericFilterOption}
                onKeyDown={handleKeyDownNumeric}
              />
            </div>

            {/* Fechas de creación */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Fecha de creación</p>
              <DateRangeFilter
                onDateRangeChange={handleDateRangeChange}
                value={selectedCreationDateRange}
              />
            </div>

            {/* Embarcación */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Centro / Embarcación</p>
              <Select
                isMulti
                isLoading={loadingCenters}
                isDisabled={loadingCenters}
                options={centersOptions}
                value={selectedCenters}
                onChange={handleCentersChange}
                placeholder="Seleccione embarcaciones"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
              />
            </div>

            {/* Estado ATC */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Estado ATC</p>
              <Select
                isMulti
                isLoading={loadingEstadoATC}
                isDisabled={loadingEstadoATC}
                options={estadoATCOptions}
                value={selectedEstadoATC}
                onChange={handleEstadoATCChange}
                placeholder="Seleccione estados ATC"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
              />
            </div>

            {/* Estado Cotización */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Estado Cotización</p>
              <Select
                isMulti
                isLoading={loadingEstadoCotizacion}
                isDisabled={loadingEstadoCotizacion}
                options={estadoCotizacionOptions}
                value={selectedEstadoCotizacion}
                onChange={handleEstadoCotizacionChange}
                placeholder="Seleccione estados cotización"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
              />
            </div>

            {/* Número Solped */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Número Solped</p>
              <Select
                isMulti
                isLoading={loadingNumeroSolped}
                isDisabled={loadingNumeroSolped}
                options={numeroSolpedOptions}
                value={selectedNumeroSolped}
                onChange={handleNumeroSolpedChange}
                placeholder="Seleccione números Solped"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                onInputChange={validateNumericInput}
                filterOption={numericFilterOption}
                onKeyDown={handleKeyDownNumeric}
              />
            </div>

            {/* Estado de Solped */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Estado de Solped</p>
              <SelectField
                title=""
                name="estadoSolped"
                value={selectedEstadoSolped}
                onChange={handleEstadoSolpedChange}
                options={[
                  { value: "true", label: "Liberado" },
                  { value: "false", label: "No liberado" }
                ]}
                placeholder="Seleccione estado"
                width="w-full"
                bgColor="bg-white"
                border="border-[#D1D5DB]"
              />
            </div>

            {/* Estado de HES */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Estado de HES</p>
              <SelectField
                title=""
                name="estadoHES"
                value={selectedEstadoHES}
                onChange={handleEstadoHESChange}
                options={[
                  { value: "true", label: "Liberado" },
                  { value: "false", label: "No liberado" }
                ]}
                placeholder="Seleccione estado"
                width="w-full"
                bgColor="bg-white"
                border="border-[#D1D5DB]"
              />
            </div>


            {/* Supervisor de mantenimiento */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Supervisor de mantenimiento</p>
              <Select
                isMulti
                isLoading={loadingSupervisor}
                isDisabled={loadingSupervisor}
                options={supervisorOptions}
                value={selectedSupervisor}
                onChange={handleSupervisorChange}
                placeholder="Seleccione supervisores"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
                onInputChange={validateTextInput}
                filterOption={textFilterOption}
                onKeyDown={handleKeyDownText}
              />
            </div>

            {/* Tipo de mantenimiento */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Tipo de mantenimiento</p>
              <Select
                isMulti
                isLoading={loadingTipoMantenimiento}
                isDisabled={loadingTipoMantenimiento}
                options={tipoMantenimientoOptions}
                value={selectedTipoMantenimiento}
                onChange={handleTipoMantenimientoChange}
                placeholder="Seleccione tipos"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
              />
            </div>

            {/* Subtipo de mantenimiento */}
            <div className='flex flex-col gap-2'>
              <p className='text-sm md:text-base text-blue font-itcbook'>Subtipo de mantenimiento</p>
              <Select
                isMulti
                isLoading={loadingSubtipoMantenimiento}
                isDisabled={loadingSubtipoMantenimiento}
                options={subtipoMantenimientoOptions}
                value={selectedSubtipoMantenimiento}
                onChange={handleSubtipoMantenimientoChange}
                placeholder="Seleccione subtipos"
                className="text-sm font-itcbook"
                noOptionsMessage={() => "No hay opciones"}
                formatCreateLabel={() => ""}
                isValidNewOption={() => false}
                styles={selectStyles}
              />
            </div>

            <div className="flex justify-center w-full pt-2">
              <button
                onClick={() => {
                  applyFilters();
                  setShowFilters(false);
                }}
                className="underline text-blue font-itcbold"
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListFilterATCAdmin;